import * as React from 'react'
import { useState } from 'react'

import Page from '../components/Page'
import Container from '../components/Container'
import IndexLayout from '../layouts'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import styled from '@emotion/styled'
import { HeroTableWithData } from '../components/tables/HeroTable'
import { AppBar, Tab, Tabs } from '@material-ui/core'
import { PlayerTableWithData } from '../components/tables/PlayerTable'

const ChartPaper = styled(Paper)`
  height: 280px;
`

const Tables = () => {
  const [value, setValue] = useState(0)

  return (
    <div>
      <AppBar position="static">
        <Tabs value={value} onChange={(event, value: number) => setValue(value)} aria-label="simple tabs example">
          <Tab label="Hero stats" />
          <Tab label="Top players (20+ games)" />
        </Tabs>
      </AppBar>

      {value === 0 && <HeroTableWithData />}
      {value === 1 && <PlayerTableWithData />}
    </div>
  )
}

const IndexPage = () => (
  <IndexLayout>
    <Page>
      <Container>
        <h1>Mid Wars Hero Stats - 4.9.1.3 (Updated 11.02.2021)</h1>
        <h3>
          Come join my discord to give feedback and discuss HoN MidWars -&gt;{' '}
          <a href="https://discord.gg/pfAR6RR">https://discord.gg/pfAR6RR</a>
        </h3>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={9}>
            <ChartPaper>
              <Tables />
            </ChartPaper>
          </Grid>
        </Grid>
      </Container>
    </Page>
  </IndexLayout>
)

export default IndexPage
